// extracted by css-extract-rspack-plugin
export default {"cls1":"SingleClaimPage-cls1_y_C","cls2":"SingleClaimPage-cls2_O1o SingleClaimPage-cls1_y_C"};